import React from 'react';

const SpeedometerGauge = ({ speed, maxSpeed, label, color, bgColor, description }) => {
  // Calculate needle angle based on speed (0-180 degrees for semicircle)
  const needleAngle = (speed / maxSpeed) * 180;
  
  // Generate tick marks
  const generateTicks = () => {
    const ticks = [];
    const tickCount = 19; // Number of tick marks
    
    for (let i = 0; i <= tickCount; i++) {
      const angle = (i / tickCount) * 180; // 0 to 180 degrees
      const radian = (angle * Math.PI) / 180;
      
      // Major ticks every 4 positions, minor ticks otherwise
      const isMajor = i % 4 === 0;
      const tickLength = isMajor ? 10 : 5;
      const tickWidth = isMajor ? 2 : 1;
      
      // Calculate positions for tick marks (inner part)
      const outerRadius = 70; // Inner position for ticks
      const innerRadius = outerRadius - tickLength;
      
      const x1 = 100 + innerRadius * Math.cos(radian - Math.PI);
      const y1 = 100 + innerRadius * Math.sin(radian - Math.PI);
      const x2 = 100 + outerRadius * Math.cos(radian - Math.PI);
      const y2 = 100 + outerRadius * Math.sin(radian - Math.PI);
      
      ticks.push(
        <line
          key={i}
          x1={x1}
          y1={y1}
          x2={x2}
          y2={y2}
          stroke="#666"
          strokeWidth={tickWidth}
        />
      );
    }
    return ticks;
  };

  return (
    <div className="row">
      <div 
        className="col mx-2 p-4 text-center my-1 my-xl-0" 
        style={{ 
          backgroundColor: bgColor, 
          border: 'none', 
          borderRadius: '15px',
        }}
      >
        <p className="mb-3 text-dark" style={{ fontSize: '13px', margin: '0 0 20px 0' }}>
          {description}
        </p>
        
        <div className="position-relative mx-auto mb-4" style={{ width: '200px', height: '110px' }}>
          <svg width="200" height="110" viewBox="0 0 200 110">
            {/* Outer colored arc */}
            <path
              d="M 15 100 A 85 85 0 0 1 185 100"
              fill="none"
              stroke={color}
              strokeWidth="8"
              strokeLinecap="square"
            />
            
            {/* Inner tick marks */}
            {generateTicks()}
            
            {/* Simple needle - straight line */}
            <line
              x1="100"
              y1="100"
              x2={100 + 65 * Math.cos((needleAngle - 180) * Math.PI / 180)}
              y2={100 + 65 * Math.sin((needleAngle - 180) * Math.PI / 180)}
              stroke="#333"
              strokeWidth="2"
              strokeLinecap="round"
            />
            
            {/* Small center circle */}
            <circle
              cx="100"
              cy="100"
              r="3"
              fill="#333"
            />
          </svg>
        </div>
        
        <div>
          <span className="text-dark" style={{ fontSize: '14px' }}>{label} : </span>
          <span style={{ color: color, fontSize: '16px', fontWeight: '600' }}>
            {speed} km/h
          </span>
        </div>
      </div>
    </div>
  );
};

export const SpeedometerDashboard = () => {
  const gauges = [
    {
      speed: 90,
      maxSpeed: 100,
      label: 'City',
      color: '#10b981',
      bgColor: '#ecfdf5',
      description: 'While driving in cities with mild traffic'
    },
    {
      speed: 80,
      maxSpeed: 100,
      label: 'Highway',
      color: '#6366f1',
      bgColor: '#eef2ff',
      description: 'While driving on highways straight route'
    },
    {
      speed: 55,
      maxSpeed: 100,
      label: 'Combined',
      color: '#ff8c00',
      bgColor: '#fef7ed',
      description: 'While driving in both highways and city'
    },
  ];

  return (
    <div className="container-fluid py-4">
        <div className="row justify-content-center">
          {gauges.map((gauge, index) => (
            <div key={index} className="col-lg-4 col-md-6">
              <SpeedometerGauge
                speed={gauge.speed}
                maxSpeed={gauge.maxSpeed}
                label={gauge.label}
                color={gauge.color}
                bgColor={gauge.bgColor}
                description={gauge.description}
              />
            </div>
          ))}
      </div>
    </div>
  );
};

